(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaDetailController', ZetaDetailController);

    ZetaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Zeta', 'Ticket', 'Venta'];

    function ZetaDetailController($scope, $rootScope, $stateParams, previousState, entity, Zeta, Ticket, Venta) {
        var vm = this;
        vm.zeta = entity;
        vm.previousState = previousState.name;
		vm.tickets = [];
		vm.vzeta = entity;
		vm.totalizado= 0.00;
		
        loadAll();

        function loadAll() {
            Ticket.queryByZeta({id: vm.zeta.id}, function(result) {
                vm.tickets = result;
                vm.searchQuery = null;
				vm.totalizado=0;				
				var maxl=vm.tickets.length;
				for (var i = 0; i < maxl; i++) { 
				  var tic = vm.tickets[i];
				  //es + ncredito porque tienen signo negativo.
				  vm.totalizado += (tic.montototal);
				}
				
            });
        } 
		
        var unsubscribe = $rootScope.$on('mVtasWebApp:zetaUpdate', function(event, result) {
            vm.zeta = result;
        });
        $scope.$on('$destroy', unsubscribe);
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'Tickets',
			  headers:true, 
			  caption: {
				  title:'Tickets',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {1:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
		
		alasql.fn.mytimeformat = function(dateStr) {
			var date = new Date(dateStr);
			return date.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}); 
			};
		
		alasql.fn.mydateformat = function(dateStr) {
			var date = new Date(dateStr);
			return date.toLocaleDateString();
			};
		var dateFormat = "dd-MM-yyyy";				
		//var fechasel= vm.zeta.fechadesde;
		//var fechasel= Venta.fecha;
		var nombrearchivoexcel= vm.zeta.comercio;//+ '_' + fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();
		vm.exportDataExcel = function () {
			alasql('SELECT mydateformat(fecha) as fecha, mytimeformat(fecha) as hora, nropv, nroticket, montototal, totalefectivo, totaltarjeta, cantitems, cliente, tipofactura, esncredito, codigomoneda  INTO XLSX("Venta_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.tickets]);   
			};
		vm.exportDataCSV = function () {
			alasql('SELECT mydateformat(fecha) as fecha, mytimeformat(fecha) as hora, nropv, nroticket, montototal, totalefectivo, totaltarjeta, cantitems, cliente, tipofactura, esncredito, codigomoneda INTO CSV("Venta_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.tickets]);   		
			};	

    }
})();
